import { forwardRef } from 'react';
import TEXT from './generated/TEXT/UpgradeModalButton';
import styles from './UpgradeModalButton.module.css';

TEXT.DEFINE({
  /** Accessibility label for upgrade modal button (screen readers only) */
  upgradePlan: 'Upgrade plan',
});

export const UpgradeModalButton = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<'div'>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.upgradeModalButton}${
      className ? ` ${className}` : ''
    }`}
    role="button"
    {...props}
  />
));

UpgradeModalButton.displayName = 'UpgradeModalButton';

export const sharedButtonProps = {
  'aria-label': TEXT.upgradePlan,
  tabIndex: 0,
};
